module.exports = __webpack_public_path__ + "img/heinrich.8a888bdb.png";